import React from 'react';
import PropTypes from 'prop-types';

import CustomButton from '../../CustomButton';

const ReportBreadcrumbBar = ({ crumbs, onBack, backLabel }) => (
    <div className="page-subheader report-breadcrumb-bar">
        <div className="report-breadcrumb">{crumbs.filter(Boolean).join(' > ')}</div>
        {onBack &&
            <CustomButton
                variant="secondary-outline"
                prefix="report-back-btn"
                onClick={onBack}
            >
                {backLabel}
            </CustomButton>
        }
    </div>
);

ReportBreadcrumbBar.propTypes = {
    crumbs: PropTypes.arrayOf(PropTypes.string).isRequired,
    onBack: PropTypes.func,
    backLabel: PropTypes.string
};

export default ReportBreadcrumbBar;
